import React, { useEffect } from "react";
import styles from "./success.module.scss";
import { Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { isNil } from "lodash";
import { getUserID } from "../../../infrastructure/backendService";

interface successComponentProps {
  showMessage?:boolean
}
const SuccessComponent = (props:successComponentProps): React.ReactElement => {
  const navigate = useNavigate();
  const { success } = useParams();
  const getMessage = ():boolean => {
    if(isNil(props.showMessage)) {
      return true
    } else {
      return false
    }
  }

  // useEffect(() => {
  //   // Automatically redirect to the main page after 3 seconds
  //   const timeoutId = setTimeout(() => {
  //     navigate("/");
  //   }, 4000);

  //   // Cleanup the timeout to avoid memory leaks
  //   return () => clearTimeout(timeoutId);
  // }, [navigate]);

  const successSvg = (): React.ReactElement => {
    return (
        <>
        <div
        className={`${styles.icon} ${styles.icon_order_success} ${styles.svg}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="154px" height="154px">
          <g fill="none" stroke="#22AE73" strokeWidth={2}>
            <circle
              cx={77}
              cy={77}
              r={72}
              style={{
                strokeDasharray: "480px, 480px",
                strokeDashoffset: "960px",
              }}
            />
            <circle
              id="colored"
              fill="#22AE73"
              cx={77}
              cy={77}
              r={72}
              style={{
                strokeDasharray: "480px, 480px",
                strokeDashoffset: "960px",
              }}
            />
            <polyline
              className="st0"
              stroke="#fff"
              strokeWidth={10}
              points="43.5,77.8 63.7,97.9 112.2,49.4 "
              style={{
                strokeDasharray: "100px, 100px",
                strokeDashoffset: "200px",
              }}
            />
          </g>
        </svg>
      </div>
      <br />
     {getMessage() ? <Typography component={"h2"} className={styles.text}>
        Volunteer Registration Successfull. Please check your registered Mail
      </Typography> : ""}
        </>
    );
  };

  const render = () : React.ReactElement => {
    if (success === "true" && !isNil(getUserID())) {
      return successSvg();
    } else {
        return <Typography component={"h2"} className={styles.text}>Please go to Volunteer Registration Page.</Typography>
    }
  };

  return (
    <div className={styles.animationCtn}>
      {successSvg()}
    </div>
  )
};

export default SuccessComponent;
